import { ReactElement } from 'react'

import Button from '@/components/base/button'
import Container from '@/components/base/container'
import CtaButton from '@/components/base/cta-button'
import DarkModeToggle from '@/components/base/dark-mode-toggle'
import Grid from '@/components/base/grid'
import SVGIcon from '@/components/base/svg-icon'
import Typography from '@/components/base/typography'
import Layout from '@/components/layout/layout'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export default function TypographyPage() {
  return (
    <Container className="py-[8rem]">
      <Grid>
        <div className="col-span-2 flex flex-col flex-wrap gap-[2rem] md:col-span-6 lg:col-span-12">
          <h1>Typography</h1>
          <DarkModeToggle />
          <div className={cn('flex flex-col gap-spacing-sm')}>
            <div className="flex gap-spacing-sm">
              <Button variant="primary">Primary Button</Button>
              <Button variant="secondary">Secondary Button</Button>
              <Button variant="link">Link Button</Button>
            </div>

            <div className="flex gap-spacing-sm">
              <CtaButton
                href="#"
                variant="link"
                typography="h6"
                iconSize="24px"
              >
                Arrow Button
              </CtaButton>

              <CtaButton
                href="#"
                variant="primary"
                typography="h6"
                iconSize="24px"
              >
                Arrow Button
              </CtaButton>
            </div>
          </div>
          <Typography className="bg-[red]/30" variant="huge" component="h1">
            {`Huge`}
          </Typography>
          <Typography className="bg-[red]/30" variant="h1" component="h1">
            {`This is an H1 <strong>Heading</strong>`}
          </Typography>
          <Typography className="bg-[red]/30" variant="h2" component="h2">
            {`This is an H2 <strong>Heading</strong>`}
          </Typography>
          <Typography className="bg-[red]/30" variant="h3" component="h3">
            {`This is an H3 <strong>Heading</strong>`}
          </Typography>
          <Typography className="bg-[red]/30" variant="h4" component="h4">
            {`This is an H4 <strong>Heading</strong>`}
          </Typography>
          <Typography className="bg-[red]/30" variant="h5" component="h5">
            {`This is an H5 <strong>Heading</strong>`}
          </Typography>
          <Typography className="bg-[red]/30" variant="h6" component="h6">
            {`This is an H6 <strong>Heading</strong>`}
          </Typography>
          <Typography className="bg-[red]/30" variant="large" paragraph>
            {`This is a paragraph of large text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography className="bg-[red]/30" variant="regular" paragraph>
            {`This is a paragraph of regular text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography className="bg-[red]/30" variant="small" paragraph>
            {`This is a paragraph of small text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography className="bg-[red]/30" variant="caption" paragraph>
            {`This is a paragraph of caption text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography className="bg-[red]/30" variant="overline" paragraph>
            {`This is a paragraph of overline text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          ROBOTO
          <Typography
            className="condensed bg-[red]/30"
            variant="huge"
            component="h1"
          >
            {`Huge`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="h1"
            component="h1"
          >
            {`This is an H1 <strong>Heading</strong>`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="h2"
            component="h2"
          >
            {`This is an H2 <strong>Heading</strong>`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="h3"
            component="h3"
          >
            {`This is an H3 <strong>Heading</strong>`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="h4"
            component="h4"
          >
            {`This is an H4 <strong>Heading</strong>`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="h5"
            component="h5"
          >
            {`This is an H5 <strong>Heading</strong>`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="h6"
            component="h6"
          >
            {`This is an H6 <strong>Heading</strong>`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="large"
            paragraph
          >
            {`This is a paragraph of large text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="regular"
            paragraph
          >
            {`This is a paragraph of regular text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="small"
            paragraph
          >
            {`This is a paragraph of small text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography
            className="text-h3 md:text-h2 condensed bg-[red]/30"
            variant="caption"
            paragraph
          >
            {`This is a paragraph of caption text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <Typography
            className="condensed bg-[red]/30"
            variant="overline"
            paragraph
          >
            {`This is a paragraph of overline text. It can include <strong>bold</strong>, <em>emphasized</em>, and <u>underlined</u> text.`}
          </Typography>
          <div>
            <SVGIcon symbol="logo" className="h-[16px] w-[116px]" />
          </div>
          <div>
            <SVGIcon symbol="zoom" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="close" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="instagram" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="linkedin" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="youtube" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="x" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="cta-arrow" className="size-[24px]" />
          </div>
          <div>
            <SVGIcon symbol="arrow-down" className="size-[24px]" />
          </div>
        </div>
      </Grid>
    </Container>
  )
}

TypographyPage.getLayout = function getLayout(
  page: ReactElement,
  pageProps: WPPageData
) {
  return <Layout pageProps={pageProps}>{page}</Layout>
}
